import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
//import { Moment } from 'moment';


import{ WorkspaceService } from './workspace.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { loginComponent } from './create-workspace/login/login.component';
import { HomeComponent } from './create-workspace/home/home.component';
import { MachineListComponent } from './create-workspace/machine-list/machine-list.component';
import { SafePipe } from './safe-pipe.service';

@NgModule({
  declarations: [
    SafePipe,
    AppComponent,
    loginComponent,
    HomeComponent,
    MachineListComponent,
  ],
  imports: [
    BrowserModule,FormsModule, AppRoutingModule,HttpModule,HttpClientModule,OwlDateTimeModule, OwlNativeDateTimeModule,BrowserAnimationsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
  providers: [WorkspaceService]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts